import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c25496f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row d-flex flex-column p-1 gap-5" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_6 = { class: "lista_atendimentos card p-0" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<li class=\"header_list d-flex col-12 p-4\" data-v-c25496f2><span class=\"col-3 d-flex justify-content-start subtitulo\" data-v-c25496f2>NOME</span><span class=\"col-3 d-flex justify-content-start subtitulo\" data-v-c25496f2>EMAIL</span><span class=\"col-2 d-flex justify-content-start subtitulo\" data-v-c25496f2>CARGO</span><span class=\"col-2 d-flex justify-content-start subtitulo\" data-v-c25496f2>DATA</span><span class=\"col-2 d-flex justify-content-start subtitulo\" data-v-c25496f2>DETALHES</span></li>", 1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "col-3 d-flex justify-content-start" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "col-3 d-flex justify-content-start" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "col-2 d-flex justify-content-start ps-2" }
const _hoisted_14 = {
  style: {"white-space":"nowrap"},
  class: "texto bold cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_15 = { class: "col-2 d-flex justify-content-start" }
const _hoisted_16 = {
  style: {"white-space":"nowrap"},
  class: "texto cor_texto_1 d-inline-block text-truncate"
}
const _hoisted_17 = { class: "d-flex justify-content-start" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_19 = {
  key: 2,
  class: "w-100 d-flex justify-content-center align-items-center p-5"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"1.125rem"},
  class: "m-0"
}, "Nenhum dado foi encontrado", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  style: {"width":"15rem","height":"3.2rem"},
  class: "card d-flex flex-row gap-2 justify-content-center align-items-center cursor-pointer"
}
const _hoisted_23 = {
  key: 0,
  style: {"color":"#dc3545"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}
const _hoisted_27 = {
  key: 2,
  style: {"font-weight":"bold","font-size":"10"},
  class: "m-0 p-0 text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_ModalUsers = _resolveComponent("ModalUsers")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Usuários " + _toDisplayString(_ctx.lojaFixada && _ctx.lojaFixada.nomeFantasia), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          style: {"width":"15vw"},
          onKeyup: _ctx.buscar,
          clearable: "",
          placeholder: "Filtre por nome, email ou cargo",
          modelValue: _ctx.fastFind,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fastFind) = $event))
        }, null, 8, ["onKeyup", "modelValue"]),
        _createVNode(_component_Button, {
          text: "Voltar",
          type: "button",
          onClick: _cache[1] || (_cache[1] = () => _ctx.router.back())
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          text: "Adicionar Usuário",
          style: {"min-width":"fit-content"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _hoisted_7,
      (_ctx.skeleton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_el_skeleton, {
              animated: "",
              rows: 15,
              class: "text-center p-5 d-block"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.usersArray.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.usersArray, (user, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              style: {"height":"fit-content","border-radius":"10px"},
              class: "usuario card d-flex flex-row col-12 p-5 align-items-center"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", {
                  style: {"white-space":"nowrap"},
                  class: "texto bold cor_texto_1 d-inline-block text-truncate",
                  title: user?.name
                }, _toDisplayString(user?.name || "-"), 9, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", {
                  style: {"white-space":"nowrap"},
                  class: "texto cor_texto_1 d-inline-block text-truncate",
                  title: user?.email
                }, _toDisplayString(user?.email || "-"), 9, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(user?.cargo || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(user.created_at ? new Date(user.created_at).toLocaleDateString("pt-BR") : "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Button, {
                  variant: "primary",
                  text: "Editar",
                  onClick: ($event: any) => (_ctx.openModal(user))
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (!_ctx.skeleton && _ctx.usersArray.length <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscaUsuario(_ctx.pagina + 1))),
      class: "align-items-center justify-content-center",
      id: "load",
      style: _normalizeStyle(`${(_ctx.usersArray.length > _ctx.limite - 1) ? 'display: flex' : 'display: none'}`)
    }, [
      _createElementVNode("div", _hoisted_22, [
        (_ctx.loadLog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        (_ctx.loadLog)
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Carregando mais"))
          : _createCommentVNode("", true),
        (!_ctx.loadLog)
          ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Carregar mais"))
          : _createCommentVNode("", true)
      ])
    ], 4),
    _createVNode(_component_ModalUsers, {
      fechaModal: _ctx.fechaModal,
      usuario: _ctx.usuarioModal
    }, null, 8, ["fechaModal", "usuario"])
  ]))
}